SET_USER_GIFT_SUBSCRIPTIONS_PROCESSING